"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hasClass;
function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);else return (" " + element.className + " ").indexOf(" " + className + " ") !== -1;
}
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./~/dom-helpers/class/hasClass.js
// module id = 111
// module chunks = 0